import { saveAs } from "file-saver";
import utils from "../../../utils/utils.js";
export default {
  async fetchFeedExportList(context, payload) {
        const mainCat = payload.catOptions.mainCat;
        const subCat = payload.catOptions.subCat;
        const detailCat = payload.catOptions.detailCat;

        payload.filter.mainCats.map(item => {
            if (item == null || item == undefined) return item;
            let match = mainCat.find(obj => obj.id === parseInt(item));
            return match ? match.id : item;
        });

        payload.filter.subCats.map(item => {
            if (item == null || item == undefined) return item;
            let match = subCat.find(obj => obj.id === parseInt(item));
            return match ? match.id : item;
        });

        payload.filter.detailCats.map(item => {
            if (item == null || item == undefined) return item;
            let match = detailCat.find(obj => obj.id === parseInt(item));
            return match ? match.id : item;
        });

        const searchBody = {
            page: payload.filter.page,
            pageSize: 10,
            sentiments: payload.filter.sentiments,
            keywords: payload.filter.keywords,
            channels: payload.filter.channels,
            sources: payload.filter.sources,
            publishers: payload.filter.publishers,
            types: payload.filter.types,
            langs: payload.filter.langs,
            relatives: payload.filter.relatives,
            mainCats: payload.filter.mainCats,
            subCats: payload.filter.subCats,
            detailCats: payload.filter.detailCats,
            years: payload.filter.years,
            months: payload.filter.months,
            days: payload.filter.days,
            date: payload.filter.date,
            searchText: payload.filter.searchText,
            showRetweets: payload.filter.showRetweets,
            sort: payload.filter.sort,
        };
        if(searchBody.page == 1)
            searchBody.pageSize = -1;
       

        const cleanRequestBody = Object.entries(searchBody)
        .filter(([key, value]) => 
            (value !== undefined && value !== null && value.length !== 0) &&
            (key !== undefined && key !== null && key.length !== 0)) 
        .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
        }, {});

        const requestBody = {
            searchParameters :  cleanRequestBody,
            reportType: payload.reportType
        };
        const response = await utils.utility.fetch(
            `api/Editor/ExportReport`,
            "POST",
            null,
            requestBody
        );
        context.commit("setFeedExportList", response.data);
    },
    async exportExcelWithMultipleSheets(_, data) {
        const fineName = `Report_${self.crypto.randomUUID()}.xlsx`;
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

        const { default: ExcelJS } = await import("exceljs");
        const workbook = new ExcelJS.Workbook();

        for (const sheetData of data) {
            if (!sheetData.data || sheetData.data.length <= 0) return;
            if (!sheetData.sheetName || sheetData.sheetName == "") return;

            let headers = [];

            if (sheetData.columnHeaders && sheetData.columnHeaders.length > 0) {
                headers = sheetData.columnHeaders;
            } else {
                headers = sheetData.data.length > 0 ? Object.keys(sheetData.data[0]).map(key => key.toUpperCase()) : [];
            }

            const worksheet = workbook.addWorksheet(`${sheetData.sheetName}`);

            const headerRow = worksheet.addRow(headers);

            headerRow.eachCell((cell) => {
                cell.font = { bold: true, size: 10, color: { argb: '000000' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            sheetData.data.forEach((row) => {
                worksheet.addRow(Object.values(row)); 
            });

            const maxColWidths = headers.map(header => header.length + 10);

            sheetData.data.forEach((row) => {
                Object.values(row).forEach((value, colIndex) => {
                    if (value) {
                        let valueLength = value.toString().length;

                        if (valueLength > 140) {
                            valueLength = 140;

                            maxColWidths[colIndex] = valueLength;
                        } else {
                            maxColWidths[colIndex] = Math.max(maxColWidths[colIndex], valueLength);
                        }
                    }
                });
            });

            worksheet.columns = headers.map((header, colIndex) => {
                const colWidth = maxColWidths[colIndex];

                return {
                    header,
                    key: `col_${colIndex}`,
                    width: colWidth
                };
            });

            worksheet.eachRow((row) => {
                row.eachCell((cell) => {
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                });
            });
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: contentType });

        saveAs(blob, fineName);
    },
    async exportExcel(_, data) {
        const listData = data.data;
        const columnHeaders = data.columnHeaders;
        const filename = data.fileName;
        const sheetName = data.sheetName;
        const contentType = data.contentType;

        const maxRowsPerSheet = 1048576; //Excel’in maksimum satır limiti
        let currentRow = 0;
        let sheetCount = 1;

        const { default: ExcelJS } = await import("exceljs");
        const workbook = new ExcelJS.Workbook();

        let headers = [];

        if (columnHeaders && columnHeaders.length > 0) {
            headers = columnHeaders;
        } else {
            headers = listData.length > 0 ? Object.keys(listData[0]).map(key => key.toUpperCase()) : [];
        }

        if (!listData || listData.length <= 0) return;
        if (!filename || filename.length <= 0) return;
        if (!sheetName || sheetName.length <= 0) return;
        if (!contentType && contentType.length <= 0) return;

        while (currentRow < listData.length) {
            const worksheet = workbook.addWorksheet(`${sheetName} ${sheetCount}`);

            const headerRow = worksheet.addRow(headers);

            headerRow.eachCell((cell) => {
                cell.font = { bold: true, size: 10, color: { argb: '000000' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            const endRow = Math.min(currentRow + maxRowsPerSheet, listData.length);
            const dataSlice = listData.slice(currentRow, endRow);

            dataSlice.forEach((row) => {
                worksheet.addRow(Object.values(row)); 
            });

            const maxColWidths = headers.map(header => header.length + 10);

            dataSlice.forEach((row) => {
                Object.values(row).forEach((value, colIndex) => {
                    if (value) {
                        let valueLength = value.toString().length;

                        if (valueLength > 140) {
                            valueLength = 140;

                            maxColWidths[colIndex] = valueLength;
                        } else {
                            maxColWidths[colIndex] = Math.max(maxColWidths[colIndex], valueLength);
                        }
                    }
                });
            });

            worksheet.columns = headers.map((header, colIndex) => {
                const colWidth = maxColWidths[colIndex];

                return {
                    header,
                    key: `col_${colIndex}`,
                    width: colWidth
                };
            });

            worksheet.eachRow((row) => {
                row.eachCell((cell) => {
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                });
            });

            currentRow = endRow;
            sheetCount++;
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: contentType });

        saveAs(blob, filename);
    },
}